// extracted by mini-css-extract-plugin
export default {"item":"Item_item__zOkxY","preview":"Item_preview__LZxoA","title":"Item_title__2nRTI","name":"Item_name__g7XQF","rank":"Item_rank__KKxlI","career":"Item_career__pfIyQ"};